var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.type)}},[_vm._v(_vm._s(_vm.type))]),(_vm.description)?_c('div',{staticClass:"clpp-api-indent clpp-api-description",domProps:{"innerHTML":_vm._s(_vm.description)}},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }